import React, { useEffect, useState } from "react";
import styles from "./styles.module.css";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { makePaymentHash } from "../../actions";
import { oneTimePayment } from "../../actions";
import ShieldTwoToneIcon from '@mui/icons-material/ShieldTwoTone';
import PayableCard from "./PayableCard";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { createSubscriptionUser } from "../../actions/index";
import { getSubscriptionUser } from "../../actions/index";
import Loading from "../../../../common/components/Loading";

const ManagePaymentTab = ({
  isPayNowBoxOpen,
  setIsPayNowBoxOpen,
  setTabChangeValue,
  getSubscriptionUser,
  createSubscriptionUser,
  payment:{
    isSubscriptionUserDetailsLoading,
    subscriptionUserFirstName,
    subscriptionUserLastName,
    subscriptionUserEmail,
    subscriptionUserAddress,
    subscriptionUserCity,
    subscriptionUserPhone,
    subscriptionUserId
  },
  auth,
}) => {

  useEffect(() => {
    getSubscriptionUser(auth.companyId);
  }, [auth.isLoading]);

  const options = ["Edit"];

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [payerDetails, setPayerDetails] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    city: "",
    address: "",
  });

  const [paymentMethod, setPaymentMethod] = useState("**** **** **** 3658");

  const [isEditable, setIsEditable] = useState(false);

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    let validationErrors = {};

    // Validate first name
    if (!payerDetails.firstName.trim()) {
      validationErrors.firstName = "First name is required";
    }

    // Validate last name
    if (!payerDetails.lastName.trim()) {
      validationErrors.lastName = "Last name is required";
    }

    // Validate email
    if (!payerDetails.email.trim()) {
      validationErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(payerDetails.email)) {
      validationErrors.email = "Email is invalid";
    }

    // Validate phone
    if (!payerDetails.phone.trim()) {
      validationErrors.phone = "Phone number is required";
    } else if (payerDetails.phone.length !== 10) {
      validationErrors.phone = "Phone number must be 10 digits";
    }

    return validationErrors;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPayerDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const handleEditClick = () => {
    setIsEditable(true);
  };

  const handleSaveClick = () => {
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    createSubscriptionUser({
      id: subscriptionUserId ? subscriptionUserId : null,
      companyId: auth.companyId,
      firstName: payerDetails.firstName,
      lastName: payerDetails.lastName,
      email: payerDetails.email,
      phone: payerDetails.phone,
      address: payerDetails.address,
      city: payerDetails.city,
    });

    setIsEditable(false);
  };

  useEffect(() => {
    setPayerDetails({
        firstName: subscriptionUserFirstName,
        lastName: subscriptionUserLastName,
        email: subscriptionUserEmail,
        phone: subscriptionUserPhone,
        city: subscriptionUserCity,
        address: subscriptionUserAddress,
      });
  }, [isSubscriptionUserDetailsLoading]);

  const ITEM_HEIGHT = 48;


  const handlePayNow = () => {
    setIsPayNowBoxOpen(!isPayNowBoxOpen);
  };

  return (
    <div className={styles.container}>

      <PayableCard
        handlePayNow={handlePayNow}
      />

      <div className={styles.middleContainer}>
        {isSubscriptionUserDetailsLoading ? (
          <div className={styles.loadingContainer}>
            <Loading />
          </div>
        ) : (
        <div className={styles.payerDetailsContainer}>
          <div className={styles.payerDetailsHeader}>
            <div className={styles.tag}>
              <h2>Payer Details</h2>
            </div>
            <div className={styles.mobileEditMenu}>
              <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={open ? "long-menu" : undefined}
                aria-expanded={open ? "true" : undefined}
                aria-haspopup="true"
                onClick={handleClick}
              >
                <MoreVertIcon />
              </IconButton>
              <Menu
                id="long-menu"
                MenuListProps={{
                  "aria-labelledby": "long-button",
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                slotProps={{
                  paper: {
                    style: {
                      maxHeight: ITEM_HEIGHT * 4.5,
                      width: "20ch",
                    },
                  },
                }}
              >
                {options.map((option) => (
                  <MenuItem
                    key={option}
                    selected={option === "Pyxis"}
                    onClick={() => {
                      handleClose();
                      if (option === "Edit") {
                        handleEditClick();
                      }
                    }}
                  >
                    {option}
                  </MenuItem>
                ))}
              </Menu>
            </div>
          </div>
          <div className={styles.payerDetails}>
            <div>
              <h3>
                First Name<span>*</span>
              </h3>
              <input
                type="text"
                name="firstName"
                value={payerDetails.firstName}
                onChange={handleInputChange}
                disabled={!isEditable}
              />
              {errors.firstName && (
                <p className={styles.errorMessage}>{errors.firstName}</p>
              )}
            </div>

            <div>
              <h3>
                Last Name<span>*</span>
              </h3>
              <input
                type="text"
                name="lastName"
                value={payerDetails.lastName}
                onChange={handleInputChange}
                disabled={!isEditable}
              />
              {errors.lastName && (
                <p className={styles.errorMessage}>{errors.lastName}</p>
              )}
            </div>

            <div>
              <h3>
                Email<span>*</span>
              </h3>
              <input
                type="email"
                name="email"
                value={payerDetails.email}
                onChange={handleInputChange}
                disabled={!isEditable}
              />
              {errors.email && (
                <p className={styles.errorMessage}>{errors.email}</p>
              )}
            </div>

            <div>
              <h3>
                Phone Number<span>*</span>
              </h3>
              <input
                type="text"
                name="phone"
                value={payerDetails.phone}
                onChange={handleInputChange}
                disabled={!isEditable}
              />
              {errors.phone && (
                <p className={styles.errorMessage}>{errors.phone}</p>
              )}
            </div>

            <div>
              <h3>Address</h3>
              <input
                type="text"
                name="address"
                value={payerDetails.address}
                onChange={handleInputChange}
                disabled={!isEditable}
              />
              <p className={styles.errorMessage}></p>
            </div>

            <div>
              <h3>City</h3>
              <input
                type="text"
                name="city"
                value={payerDetails.city}
                onChange={handleInputChange}
                disabled={!isEditable}
              />
              <p className={styles.errorMessage}></p>
            </div>
          </div>
          {/* Toggle between Edit and Save - Right Aligned Button */}
          <div className={styles.buttonContainer}>
            <button
              className={styles.buttonRightAligned}
              onClick={isEditable ? handleSaveClick : handleEditClick}
            >
              {isEditable ? "Save" : "Edit"}
            </button>
          </div>
        </div>
        )}
      </div>
    </div>
  );
};

ManagePaymentTab.propTypes = {
  createSubscriptionUser: PropTypes.func.isRequired,
  getSubscriptionUser: PropTypes.func.isRequired,
  setTabChangeValue: PropTypes.func.isRequired,
  payment: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  payment: state.paymentState,
  auth: state.authState,
});

export default connect(mapStateToProps, { createSubscriptionUser, getSubscriptionUser })(
  ManagePaymentTab
);
